package team.platforma.multiplatform_material_extension.calendar.core.core_ui

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import kotlinx.datetime.Clock
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.todayIn
import team.platforma.multiplatform_material_extension.calendar.style.CalendarViewStyle
import team.platforma.multiplatform_material_extension.calendar.utils.CalendarRange
import team.platforma.multiplatform_material_extension.calendar.utils.daysInMonth
import team.platforma.multiplatform_material_extension.scrollbar.VerticalScrollIndicator

@Composable
internal fun ChangeYearView(
    selectedDate: LocalDate,
    onDateSelected: (LocalDate) -> Unit,
    calendarRange: CalendarRange
) {
    val dateNow: LocalDate = Clock.System.todayIn(TimeZone.currentSystemDefault())

    val years = (calendarRange.max.year..calendarRange.min.year).toList().reversed()
    val rows = years.chunked(3)


    val selectedRowIndex = rows.indexOfFirst { row -> selectedDate.year in row }

    val lazyListState = rememberLazyListState()

    LaunchedEffect(selectedRowIndex) {
        if (selectedRowIndex >= 0) {
            lazyListState.scrollToItem(selectedRowIndex)
        }
    }

    VerticalScrollIndicator(
        state = lazyListState
    ) {
        LazyColumn(
            modifier = Modifier
                .fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(8.dp),
            state = lazyListState
        ) {

            items(rows) { row ->

                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceAround
                ) {
                    row.forEach { year ->
                        Box(
                            modifier = Modifier
                                .weight(1f)
                                .padding(4.dp),
                            contentAlignment = Alignment.Center
                        ) {
                            Box(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .clip(CalendarViewStyle.dateStyle().shape)
                                    .background(
                                        color = if (year == selectedDate.year) CalendarViewStyle.dateStyle().checkedDateBackground else CalendarViewStyle.dateStyle().defaultDateBackground,
                                        shape = CalendarViewStyle.dateStyle().shape
                                    )
                                    .border(
                                        width = CalendarViewStyle.dateStyle().borderWidth,
                                        color = if (year == selectedDate.year || year == dateNow.year) CalendarViewStyle.dateStyle().checkedDateBorder else CalendarViewStyle.dateStyle().defaultDateBorder,
                                        shape = CalendarViewStyle.dateStyle().shape
                                    )
                                    .clickable {
                                        val resultDate = LocalDate(
                                            year,
                                            selectedDate.monthNumber,
                                            selectedDate.dayOfMonth.coerceAtMost(
                                                daysInMonth(year, selectedDate.monthNumber)
                                            )
                                        )
                                        val adjustedDate =
                                            resultDate.coerceIn(calendarRange.max, calendarRange.min)

                                        onDateSelected(adjustedDate)
                                    },
                                contentAlignment = Alignment.Center
                            ) {
                                Text(
                                    modifier = Modifier.padding(4.dp),
                                    text = "$year",
                                    style = MaterialTheme.typography.bodyLarge,
                                    color = if (year == selectedDate.year) {
                                        CalendarViewStyle.dateStyle().checkedDateText
                                    } else {
                                        CalendarViewStyle.dateStyle().enabledDateText
                                    }
                                )
                            }

                        }
                    }

                }
            }
        }
    }




}